export default __webpack_public_path__ + "static/media/flag.8b3048c6.svg";